<script>
    import {onMount} from 'svelte';
    import Chart from 'chart.js';
    import Common from '../public/lib/common';
    import 'chartjs-plugin-labels';

    export let labelsData;
    export let valuesData;
    export let titleData;


    let outer = Common.randomString();
    let inner = Common.randomString();

    export function setup() {

        // let w = jQuery('#' + outer).width();
        // jQuery('#' + outer).css({'height': w / 2 + 'px'});
        //
        // jQuery('#' + inner).css({'width': w + 'px'});
        // jQuery('#' + inner).css({'height': w / 2 - 10 + 'px'});


        var chartCtx = jQuery("#" + inner).get(0).getContext("2d");
        new Chart(chartCtx, {
            type: 'line',
            data: {
                labels: labelsData,
                datasets: [{
                    label: titleData,
                    data: valuesData,
                    fill: false,
                    borderColor: 'rgb(75, 192, 192)',
                    tension: 0.1
                }]
            },
            options: {
                legend: {
                    labels: {
                        fontColor: "white",
                        fontSize: 20
                    }
                },
                scales: {
                    xAxes: [{
                        display: true,
                        scaleLabel: {
                            display: true,
                            fontColor: 'white',
                            fontSize: 16
                        },
                        ticks: {
                            fontColor: "white",
                            fontSize: 16
                        }
                    }],
                    yAxes: [{
                        display: true,
                        scaleLabel: {
                            display: true,
                            fontColor: 'white',
                            fontSize: 16
                        },
                        ticks: {
                            fontColor: "white",
                            fontSize: 16
                        }
                    }]
                }
            }
        });
    };

</script>

<main class="chart-container" id="{outer}">
    <canvas id="{inner}">
    </canvas>
</main>

<style>

</style>
